module.exports = __webpack_public_path__ + "img/banner-1.eabdb3d8.jpg";